<!-- Hero Section -->
<section id="hero">
  <app-sales-hero></app-sales-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-sales-overview></app-sales-overview>
</section>

<!-- Screens Section -->
<section id="screens">
  <app-sales-mobile></app-sales-mobile>
</section>

<!-- Features Section -->
<section id="features">
  <app-sales-features></app-sales-features>
</section>

<!-- CTA Section -->
<section id="cta">
  <app-sales-cta></app-sales-cta>
</section>
